
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Servicios from '../pages/servicios/page';
import Contacto from '../pages/contacto/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/servicios',
    element: <Servicios />,
  },
  {
    path: '/contacto',
    element: <Contacto />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
